import styled from 'styled-components';

export const SwitchBody = styled.div`
  margin: 8px 0 0;
  display: flex;
  align-items: center;
`;

export const SwitchText = styled.div`
  display: inline;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 0.8em;
  line-height: 1;
`;
